export default __webpack_public_path__ + "static/media/tourpng.5bf9670e.png";